import { asyncComponent } from "../../../asyncComponent";

import { IconDictionary } from "./types";

export const DEPRECATED_ICONS = [
  "back",
  "remove",
  "find",
  "surveys",
  "datepicker_nav",
  "check",
  "bell",
  "open_caret",
  "open_caret_left",
  "open_caret_up",
  "open_caret_down",
  "company_links",
  "birthday_cake",
  "anniversary_cal",
  "rating",
  "high_five_hollow",
  "up_arrow",
  "down_arrow",
  "filter_menu",
  "link_feature",
  "nomination",
  "kazoo_logo",
];

export const IconMap: Record<
  IconDictionary | (string & Record<never, never>),
  any
> = {
  add_user: asyncComponent({
    module: () => import("./icons/AddUser"),
    component: (module) => module.add_user,
  }),
  admin: asyncComponent({
    module: () => import("./icons/Admin"),
    component: (module) => module.admin,
  }),
  ai_general: asyncComponent({
    module: () => import("./icons/AiGeneral"),
    component: (module) => module.ai_general,
  }),
  ai_scoring: asyncComponent({
    module: () => import("./icons/AiScoring"),
    component: (module) => module.ai_scoring,
  }),
  ai_text: asyncComponent({
    module: () => import("./icons/AiText"),
    component: (module) => module.ai_text,
  }),
  anniversary: asyncComponent({
    module: () => import("./icons/Anniversary"),
    component: (module) => module.anniversary,
  }),
  arrow_up: asyncComponent({
    module: () => import("./icons/ArrowUp"),
    component: (module) => module.arrow_up,
  }),
  arrow_right: asyncComponent({
    module: () => import("./icons/ArrowRight"),
    component: (module) => module.arrow_right,
  }),
  arrow_down: asyncComponent({
    module: () => import("./icons/ArrowDown"),
    component: (module) => module.arrow_down,
  }),
  arrow_left: asyncComponent({
    module: () => import("./icons/ArrowLeft"),
    component: (module) => module.arrow_left,
  }),
  attachment: asyncComponent({
    module: () => import("./icons/Attachment"),
    component: (module) => module.attachment,
  }),
  birthday: asyncComponent({
    module: () => import("./icons/Birthday"),
    component: (module) => module.birthday,
  }),
  calendar: asyncComponent({
    module: () => import("./icons/Calendar"),
    component: (module) => module.calendar,
  }),
  caret_down: asyncComponent({
    module: () => import("./icons/CaretDown"),
    component: (module) => module.caret_down,
  }),
  caret_dn: asyncComponent({
    module: () => import("./icons/CaretDn"),
    component: (module) => module.caret_dn,
  }),
  caret_left: asyncComponent({
    module: () => import("./icons/CaretLeft"),
    component: (module) => module.caret_left,
  }),
  caret_right: asyncComponent({
    module: () => import("./icons/CaretRight"),
    component: (module) => module.caret_right,
  }),
  caret_up: asyncComponent({
    module: () => import("./icons/CaretUp"),
    component: (module) => module.caret_up,
  }),
  check_in: asyncComponent({
    module: () => import("./icons/CheckIn"),
    component: (module) => module.check_in,
  }),
  check_seal: asyncComponent({
    module: () => import("./icons/CheckSeal"),
    component: (module) => module.check_seal,
  }),
  checkmark: asyncComponent({
    module: () => import("./icons/Checkmark"),
    component: (module) => module.checkmark,
  }),
  close: asyncComponent({
    module: () => import("./icons/Close"),
    component: (module) => module.close,
  }),
  clock: asyncComponent({
    module: () => import("./icons/Clock"),
    component: (module) => module.clock,
  }),
  cloud_download: asyncComponent({
    module: () => import("./icons/CloudDownload"),
    component: (module) => module.cloud_download,
  }),
  comment: asyncComponent({
    module: () => import("./icons/Comment"),
    component: (module) => module.comment,
  }),
  copy: asyncComponent({
    module: () => import("./icons/Copy"),
    component: (module) => module.copy,
  }),
  dot: asyncComponent({
    module: () => import("./icons/Dot"),
    component: (module) => module.dot,
  }),
  download: asyncComponent({
    module: () => import("./icons/Download"),
    component: (module) => module.download,
  }),
  drag: asyncComponent({
    module: () => import("./icons/Drag"),
    component: (module) => module.drag,
  }),
  drag_indicator: asyncComponent({
    module: () => import("./icons/DragIndicator"),
    component: (module) => module.drag_indicator,
  }),
  feedback: asyncComponent({
    module: () => import("./icons/Feedback"),
    component: (module) => module.feedback,
  }),
  filter: asyncComponent({
    module: () => import("./icons/Filter"),
    component: (module) => module.filter,
  }),
  flag: asyncComponent({
    module: () => import("./icons/Flag"),
    component: (module) => module.flag,
  }),
  goal_count: asyncComponent({
    module: () => import("./icons/GoalCount"),
    component: (module) => module.goal_count,
  }),
  earn: asyncComponent({
    module: () => import("./icons/Earn"),
    component: (module) => module.earn,
  }),
  email: asyncComponent({
    module: () => import("./icons/Email"),
    component: (module) => module.email,
  }),
  expired: asyncComponent({
    module: () => import("./icons/Expired"),
    component: (module) => module.expired,
  }),
  eye: asyncComponent({
    module: () => import("./icons/Eye"),
    component: (module) => module.eye,
  }),
  giphy: asyncComponent({
    module: () => import("./icons/Giphy"),
    component: (module) => module.giphy,
  }),
  help: asyncComponent({
    module: () => import("./icons/Help"),
    component: (module) => module.help,
  }),
  home: asyncComponent({
    module: () => import("./icons/Home"),
    component: (module) => module.home,
  }),
  goal_percent: asyncComponent({
    module: () => import("./icons/GoalPercent"),
    component: (module) => module.goal_percent,
  }),
  goal_task: asyncComponent({
    module: () => import("./icons/GoalTask"),
    component: (module) => module.goal_task,
  }),
  goals: asyncComponent({
    module: () => import("./icons/Goals"),
    component: (module) => module.goals,
  }),
  hamburger: asyncComponent({
    module: () => import("./icons/Hamburger"),
    component: (module) => module.hamburger,
  }),
  high_five: asyncComponent({
    module: () => import("./icons/HighFive"),
    component: (module) => module.high_five,
  }),
  horizontal_line: asyncComponent({
    module: () => import("./icons/HorizontalLine"),
    component: (module) => module.horizontal_line,
  }),
  hourglass: asyncComponent({
    module: () => import("./icons/Hourglass"),
    component: (module) => module.hourglass,
  }),
  image: asyncComponent({
    module: () => import("./icons/Image"),
    component: (module) => module.image,
  }),
  image_file: asyncComponent({
    module: () => import("./icons/ImageFile"),
    component: (module) => module.image_file,
  }),
  media_error: asyncComponent({
    module: () => import("./icons/MediaError"),
    component: (module) => module.media_error,
  }),
  info: asyncComponent({
    module: () => import("./icons/Info"),
    component: (module) => module.info,
  }),
  insights: asyncComponent({
    module: () => import("./icons/Insights"),
    component: (module) => module.insights,
  }),
  link: asyncComponent({
    module: () => import("./icons/Link"),
    component: (module) => module.link,
  }),
  link_arrow: asyncComponent({
    module: () => import("./icons/LinkArrow"),
    component: (module) => module.link_arrow,
  }),
  loading: asyncComponent({
    module: () => import("./icons/Loading"),
    component: (module) => module.loading,
  }),
  lock: asyncComponent({
    module: () => import("./icons/Lock"),
    component: (module) => module.lock,
  }),
  meatball_menu: asyncComponent({
    module: () => import("./icons/MeatballMenu"),
    component: (module) => module.meatball_menu,
  }),
  microphone: asyncComponent({
    module: () => import("./icons/Microphone"),
    component: (module) => module.microphone,
  }),
  nomination: asyncComponent({
    module: () => import("./icons/Nomination"),
    component: (module) => module.nomination,
  }),
  pause: asyncComponent({
    module: () => import("./icons/Pause"),
    component: (module) => module.Pause,
  }),
  pencil: asyncComponent({
    module: () => import("./icons/Pencil"),
    component: (module) => module.pencil,
  }),
  people: asyncComponent({
    module: () => import("./icons/People"),
    component: (module) => module.people,
  }),
  pin: asyncComponent({
    module: () => import("./icons/Pin"),
    component: (module) => module.pin,
  }),
  pinned_icon_award: asyncComponent({
    module: () => import("./icons/PinnedIconAward"),
    component: (module) => module.pinned_icon_award,
  }),
  pinned_icon_bright_idea: asyncComponent({
    module: () => import("./icons/PinnedIconBrightIdea"),
    component: (module) => module.pinned_icon_bright_idea,
  }),
  pinned_icon_bullseye: asyncComponent({
    module: () => import("./icons/PinnedIconBullseye"),
    component: (module) => module.pinned_icon_bullseye,
  }),
  pinned_icon_champagne: asyncComponent({
    module: () => import("./icons/PinnedIconChampagne"),
    component: (module) => module.pinned_icon_champagne,
  }),
  pinned_icon_cheer: asyncComponent({
    module: () => import("./icons/PinnedIconCheer"),
    component: (module) => module.pinned_icon_cheer,
  }),
  pinned_icon_crown: asyncComponent({
    module: () => import("./icons/PinnedIconCrown"),
    component: (module) => module.pinned_icon_crown,
  }),
  pinned_icon_diamond: asyncComponent({
    module: () => import("./icons/PinnedIconDiamond"),
    component: (module) => module.pinned_icon_diamond,
  }),
  pinned_icon_hole_in_one: asyncComponent({
    module: () => import("./icons/PinnedIconHoleInOne"),
    component: (module) => module.pinned_icon_hole_in_one,
  }),
  pinned_icon_medal: asyncComponent({
    module: () => import("./icons/PinnedIconMedal"),
    component: (module) => module.pinned_icon_medal,
  }),
  pinned_icon_metrics: asyncComponent({
    module: () => import("./icons/PinnedIconMetrics"),
    component: (module) => module.pinned_icon_metrics,
  }),
  pinned_icon_pin: asyncComponent({
    module: () => import("./icons/PinnedIconPin"),
    component: (module) => module.pinned_icon_pin,
  }),
  pinned_icon_rock_and_roll: asyncComponent({
    module: () => import("./icons/PinnedIconRockAndRoll"),
    component: (module) => module.pinned_icon_rock_and_roll,
  }),
  pinned_icon_rocket: asyncComponent({
    module: () => import("./icons/PinnedIconRocket"),
    component: (module) => module.pinned_icon_rocket,
  }),
  pinned_icon_strength: asyncComponent({
    module: () => import("./icons/PinnedIconStrength"),
    component: (module) => module.pinned_icon_strength,
  }),
  pinned_icon_teddy_bear: asyncComponent({
    module: () => import("./icons/PinnedIconTeddyBear"),
    component: (module) => module.pinned_icon_teddy_bear,
  }),
  platform_logo: asyncComponent({
    module: () => import("./icons/PlatformLogo"),
    component: (module) => module.platform_logo,
  }),
  plus: asyncComponent({
    module: () => import("./icons/Plus"),
    component: (module) => module.plus,
  }),
  notification: asyncComponent({
    module: () => import("./icons/Notification"),
    component: (module) => module.notification,
  }),
  private_eye: asyncComponent({
    module: () => import("./icons/PrivateEye"),
    component: (module) => module.private_eye,
  }),
  private_push_pin: asyncComponent({
    module: () => import("./icons/PrivatePushPin"),
    component: (module) => module.private_push_pin,
  }),
  progress_circle: asyncComponent({
    module: () => import("./icons/ProgressCircle"),
    component: (module) => module.progress_circle,
  }),
  push_pin: asyncComponent({
    module: () => import("./icons/PushPin"),
    component: (module) => module.push_pin,
  }),
  quotes_left: asyncComponent({
    module: () => import("./icons/QuotesLeft"),
    component: (module) => module.quotes_left,
  }),
  quotes_right: asyncComponent({
    module: () => import("./icons/QuotesRight"),
    component: (module) => module.quotes_right,
  }),
  recognition: asyncComponent({
    module: () => import("./icons/Recognition"),
    component: (module) => module.recognition,
  }),
  rewards: asyncComponent({
    module: () => import("./icons/Rewards"),
    component: (module) => module.rewards,
  }),
  roadmap: asyncComponent({
    module: () => import("./icons/Roadmap"),
    component: (module) => module.roadmap,
  }),
  send_recognition: asyncComponent({
    module: () => import("./icons/SendRecognition"),
    component: (module) => module.send_recognition,
  }),
  share_link: asyncComponent({
    module: () => import("./icons/ShareLink"),
    component: (module) => module.share_link,
  }),
  sidebar_collapse: asyncComponent({
    module: () => import("./icons/SidebarCollapse"),
    component: (module) => module.sidebar_collapse,
  }),
  skill: asyncComponent({
    module: () => import("./icons/Skill"),
    component: (module) => module.skill,
  }),
  smiley: asyncComponent({
    module: () => import("./icons/Smiley"),
    component: (module) => module.smiley,
  }),
  search: asyncComponent({
    module: () => import("./icons/Search"),
    component: (module) => module.search,
  }),
  survey: asyncComponent({
    module: () => import("./icons/Survey"),
    component: (module) => module.survey,
  }),
  surveys: asyncComponent({
    module: () => import("./icons/Survey"),
    component: (module) => module.survey,
  }),
  syncs: asyncComponent({
    module: () => import("./icons/Syncs"),
    component: (module) => module.syncs,
  }),
  talent_review: asyncComponent({
    module: () => import("./icons/TalentReview"),
    component: (module) => module.talent_review,
  }),
  talent_review_insights: asyncComponent({
    module: () => import("./icons/TalentReviewInsights"),
    component: (module) => module.talent_review_insights,
  }),
  task_completed: asyncComponent({
    module: () => import("./icons/TaskCompleted"),
    component: (module) => module.task_completed,
  }),
  teams: asyncComponent({
    module: () => import("./icons/Teams"),
    component: (module) => module.teams,
  }),
  text_bold: asyncComponent({
    module: () => import("./icons/TextBold"),
    component: (module) => module.text_bold,
  }),
  text_bulletlist: asyncComponent({
    module: () => import("./icons/TextBulletList"),
    component: (module) => module.text_bulletlist,
  }),
  text_input: asyncComponent({
    module: () => import("./icons/TextInput"),
    component: (module) => module.text_input,
  }),
  text_italic: asyncComponent({
    module: () => import("./icons/TextItalic"),
    component: (module) => module.text_italic,
  }),
  text_numberlist: asyncComponent({
    module: () => import("./icons/TextNumberList"),
    component: (module) => module.text_numberlist,
  }),
  text_underline: asyncComponent({
    module: () => import("./icons/TextUnderline"),
    component: (module) => module.text_underline,
  }),
  toggle: asyncComponent({
    module: () => import("./icons/Toggle"),
    component: (module) => module.toggle,
  }),
  trash: asyncComponent({
    module: () => import("./icons/Trash"),
    component: (module) => module.trash,
  }),
  trend_down: asyncComponent({
    module: () => import("./icons/TrendDown"),
    component: (module) => module.trend_down,
  }),
  trend_up: asyncComponent({
    module: () => import("./icons/TrendUp"),
    component: (module) => module.trend_up,
  }),
  warning: asyncComponent({
    module: () => import("./icons/Warning"),
    component: (module) => module.warning,
  }),
  up_down_caret: asyncComponent({
    module: () => import("./icons/UpDownCaret"),
    component: (module) => module.up_down_caret,
  }),
  verified_checkmark: asyncComponent({
    module: () => import("./icons/VerifiedCheckmark"),
    component: (module) => module.verified_checkmark,
  }),
  vertical_line: asyncComponent({
    module: () => import("./icons/VerticalLine"),
    component: (module) => module.vertical_line,
  }),
  warning_no_outline: asyncComponent({
    module: () => import("./icons/WarningNoOutline"),
    component: (module) => module.warning_no_outline,
  }),

  // Deprecated icons below
  // --------------------------------------------------------------------------

  anniversary_cal: asyncComponent({
    module: () => import("./icons/Anniversary"),
    component: (module) => module.anniversary,
  }),
  back: asyncComponent({
    module: () => import("./icons/ArrowLeft"),
    component: (module) => module.arrow_left,
  }),
  bell: asyncComponent({
    module: () => import("./icons/Notification"),
    component: (module) => module.notification,
  }),
  birthday_cake: asyncComponent({
    module: () => import("./icons/Birthday"),
    component: (module) => module.birthday,
  }),
  check: asyncComponent({
    module: () => import("./icons/Checkmark"),
    component: (module) => module.checkmark,
  }),
  company_links: asyncComponent({
    module: () => import("./icons/Link"),
    component: (module) => module.link,
  }),
  datepicker_nav: asyncComponent({
    module: () => import("./icons/ArrowLeft"),
    component: (module) => module.arrow_left,
  }),
  down_arrow: asyncComponent({
    module: () => import("./icons/CaretDn"),
    component: (module) => module.caret_dn,
  }),
  filter_menu: asyncComponent({
    module: () => import("./icons/Filter"),
    component: (module) => module.filter,
  }),
  find: asyncComponent({
    module: () => import("./icons/Search"),
    component: (module) => module.search,
  }),
  high_five_hollow: asyncComponent({
    module: () => import("./icons/HighFive"),
    component: (module) => module.high_five,
  }),
  kazoo_logo: asyncComponent({
    module: () => import("./icons/KazooLogo"),
    component: (module) => module.kazoo_logo,
  }),
  link_feature: asyncComponent({
    module: () => import("./icons/Link"),
    component: (module) => module.link,
  }),
  open_caret: asyncComponent({
    module: () => import("./icons/CaretRight"),
    component: (module) => module.caret_right,
  }),
  open_caret_down: asyncComponent({
    module: () => import("./icons/CaretDn"),
    component: (module) => module.caret_dn,
  }),
  open_caret_left: asyncComponent({
    module: () => import("./icons/CaretLeft"),
    component: (module) => module.caret_left,
  }),
  open_caret_up: asyncComponent({
    module: () => import("./icons/CaretUp"),
    component: (module) => module.caret_up,
  }),
  rating: asyncComponent({
    module: () => import("./icons/Earn"),
    component: (module) => module.earn,
  }),
  remove: asyncComponent({
    module: () => import("./icons/Close"),
    component: (module) => module.close,
  }),
  up_arrow: asyncComponent({
    module: () => import("./icons/CaretUp"),
    component: (module) => module.caret_up,
  }),
  undo: asyncComponent({
    module: () => import("./icons/Undo"),
    component: (module) => module.undo,
  }),
  translate: asyncComponent({
    module: () => import("./icons/Translate"),
    component: (module) => module.translate,
  }),
  thumbs_up: asyncComponent({
    module: () => import("./icons/ThumbsUp"),
    component: (module) => module.thumbsUp,
  }),
  thumbs_down: asyncComponent({
    module: () => import("./icons/ThumbsDown"),
    component: (module) => module.thumbsDown,
  }),
};
